import { c as _c } from "react/compiler-runtime";
import { useState, type FormEvent } from 'react';
import { Button, FullModal, TextField } from '@sbt-web/ui';
import styles from './index.module.scss';
export type PhoneDialogProps = {
  isOpened: boolean;
  onClose: () => void;
  onSubmit: (phoneNumber: string) => void;
};
const ERROR_MESSAGE = 'Inserisci un numero di telefono valido';
export const isValidPhoneNumber = (phoneNumber: string): boolean => /^((00|\+))?\d{6,15}$/.test(phoneNumber);
export const PhoneDialog = t0 => {
  const $ = _c(21);
  const {
    isOpened,
    onClose,
    onSubmit
  } = t0;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = phone => setError(isValidPhoneNumber(phone) ? undefined : ERROR_MESSAGE);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const validatePhoneNumber = t1;
  let t2;
  if ($[1] !== onSubmit || $[2] !== phoneNumber) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      if (isValidPhoneNumber(phoneNumber)) {
        onSubmit(phoneNumber);
        setPhoneNumber("");
      } else {
        setError(ERROR_MESSAGE);
      }
    };
    $[1] = onSubmit;
    $[2] = phoneNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSubmit = t2;
  let t3;
  if ($[4] !== onClose) {
    t3 = () => {
      setError(undefined);
      setPhoneNumber("");
      onClose();
    };
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClose = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles.marginBottom}><p className="body-text">Concludi l'affare più velocemente: aggiungi il tuo numero di telefono, sarà inoltrato insieme al tuo messaggio.</p></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: "Numero di telefono"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e_0 => {
      setPhoneNumber(e_0.target.value);
      validatePhoneNumber(e_0.target.value);
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = error !== undefined;
  let t8;
  if ($[9] !== error || $[10] !== phoneNumber || $[11] !== t7) {
    t8 = <div className={styles.marginBottom}><TextField name="phone" placeholder="Inserisci il tuo numero" inputHeaderProps={t5} value={phoneNumber} onInputChange={t6} errorMessage={error} errorState={t7} type="tel" /></div>;
    $[9] = error;
    $[10] = phoneNumber;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={styles.buttonWrapper}><Button type="submit" classes={[styles.submitButton]}>Conferma</Button></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== handleSubmit || $[15] !== t8) {
    t10 = <form className={styles.body} method="POST" onSubmit={handleSubmit} name="phone_number_form">{t4}{t8}{t9}</form>;
    $[14] = handleSubmit;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== handleClose || $[18] !== isOpened || $[19] !== t10) {
    t11 = <FullModal open={isOpened} onClose={handleClose} title="Telefono">{t10}</FullModal>;
    $[17] = handleClose;
    $[18] = isOpened;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};